import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FiltersPanel.css";

const FiltersPanel = ({ isOpen, onClose, children, onApply }) => {
    const { t } = useTranslation();
    const [isClosing, setIsClosing] = useState(false);

    // Empêche la carte Leaflet de bouger quand le panneau est ouvert
    useEffect(() => {
        const mapContainer = document.querySelector(".leaflet-container");
        if (!mapContainer) return;

        if (isOpen) {
            mapContainer.style.pointerEvents = "none"; // bloque la carte
        } else {
            mapContainer.style.pointerEvents = "auto"; // réactive la carte
        }

        return () => {
            mapContainer.style.pointerEvents = "auto";
        };
    }, [isOpen]);

    // Gestion du scroll & des animations
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden"; // empêche de scroller derrière
        } else {
            document.body.style.overflow = "";
        }
    }, [isOpen]);

    // Animation de fermeture avant suppression
    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            onClose();
        }, 300);
    };

    if (!isOpen && !isClosing) return null;

    return (
        <div className="filters-overlay" onClick={handleClose}>
            <div
                className={`filters-panel ${isClosing ? "closing" : "open"}`}
                onClick={(e) => e.stopPropagation()} // bloque clic intérieur
            >
                {/* Barre supérieure */}
                <div className="filters-header">
                    <div className="filters-drag-bar" />
                    <h3>{t('filters.title')}</h3>
                    <button className="filters-close-btn" onClick={handleClose}>
                        ✕
                    </button>
                </div>

                {/* Contenu (filtres venant de Header.js) */}
                <div className="filters-content">{children}</div>

                {/* Boutons en bas */}
                <div className="filters-footer">
                    <button className="filters-apply-btn" onClick={onApply}>
                        {t('filters.apply')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FiltersPanel;
